import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { tickerReports } from '@/config/tickerReports';
import AxionTickerReport from './HistoryPage';

const tickerDataModules = import.meta.glob<{ data: Record<string, unknown>; accent: string }>(
  '@/generated/tickerData/*.ts',
);

const TickerReportPage = () => {
  const { ticker = '' } = useParams();
  const symbol = ticker.toUpperCase().trim();
  const config = tickerReports.find((t) => t.ticker.toUpperCase() === symbol);
  const [data, setData] = useState<Record<string, unknown> | null>(() => {
    const path = `/src/generated/tickerData/${symbol}.ts`;
    if (!symbol || !tickerDataModules[path]) {
      return symbol ? { ticker: symbol, notFound: true } : null;
    }
    return null;
  });

  useEffect(() => {
    if (!symbol) return;
    const path = `/src/generated/tickerData/${symbol}.ts`;
    const loader = tickerDataModules[path];
    if (!loader) return;
    let cancelled = false;
    loader().then((mod) => {
      if (!cancelled) setData(mod.data);
    });
    return () => { cancelled = true; };
  }, [symbol]);

  return (
    <AxionTickerReport
      ticker={symbol}
      initialData={data}
      accent={config?.accent}
    />
  );
};

export default TickerReportPage;
